import React from 'react'
import {Button, Card, Image } from 'semantic-ui-react'
import { MyStore } from "../../../../services/Store"
const UserCardsMessage = (props) => {
    // console.log(props)
    let listMembers = '';
    const databaseRef = MyStore.database().ref();


    
    const recipeKey = '-LwLujWwcsr6szQxZYer';
    // const cardId = '-M0a4x5v51tgt9HL6OET'

    let currentUserUid = MyStore.auth().currentUser.uid

    const handleRemoveUser=(member)=>{
        databaseRef.child(`/groups/${recipeKey}`).child('mbrcards').child(props.filelogid).child(member.uid).remove()
        databaseRef.child(`/groups/${recipeKey}`).child('mbrprojects').child(member.uid).child('cards').child(props.filelogid).remove()
    }


    // let userRef = this.database.ref('users/' + userId);
    // userRef.remove()

    if (props.members ){
      
        // console.log(props)

        

        // listMembers = props.members.map((member) =>
        // <Table.Row  key={props.member.username}>
        // <Table.Cell collapsing>
        //     <Checkbox toggle />
        // </Table.Cell>
        // <Table.Cell>{props.member.username}</Table.Cell>
        
        //     </Table.Row>
        //     );
        const paragraph = <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />

        return(
            // listMembers = props.members.map((member) =>

            Array.from(props.members.keys()).map(key => 


 
        
 

 





        <Card style={{width:"9em", margin:"1.5em", padding:"0em", float:"left", height: '16em'}} key={key}> 
        <Card.Content style={{margin:'justified'}}>
                <Image
                // floated='justified'
                // size='mini'
                style={{padding:".3em"}}
                src={ props.members[key].avatar}
                />
                <Card.Header>{props.members[key].username}</Card.Header>
 
                <Card.Meta>{props.members[key].role} </Card.Meta>
                <Card.Description>
                    {props.members[key].displayName}
                {/* Steve wants to add you to the group <strong>best friends</strong> */}
                </Card.Description>
                {/* <Card.Meta>Remove</Card.Meta> */}
                <Card.Description>

                {currentUserUid !== props.members[key].uid ? 
                         <Button fluid icon='remove user' size='large' inverted color={'red'}
                         value={key}
                         onClick={() => handleRemoveUser(props.members[key])}>
                     </Button> 
                :            
                    <Button fluid  size='large'   deactivate
                     inverted color='green'
                    >joined</Button>  
            }
       
                </Card.Description>
            </Card.Content>

        </Card>






 

        )
        )
    }
 
}

export default UserCardsMessage